import { Link, useLocation } from "react-router-dom";
import { AI_BG_NEW, AI_HERO_GIF } from "../../assets";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { MOTION_OK, maskedLineReveal } from "../../utils/animations";

export const Hero = () => {
  const { hash } = useLocation();
  const sectionRef = useRef(null);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        // The hero intro plays once on load and never restarts.
        maskedLineReveal(sectionRef.current.querySelector(".hero-heading"));
        gsap
          .timeline({ defaults: { ease: "power4.out" } })
          .from(".hero-copy", { y: 28, autoAlpha: 0, duration: 0.9 }, 0.35)
          .from(
            ".hero-cta > *",
            { y: 24, autoAlpha: 0, duration: 0.8, stagger: 0.12 },
            0.5
          )
          .from(
            ".hero-media",
            { y: 48, autoAlpha: 0, scale: 1.2, duration: 1.5 },
            0.4
          );
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section
      ref={sectionRef}
      style={{
        backgroundImage: `url("${AI_BG_NEW}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="min-h-[100vh] flex items-center"
    >
      <div className="container mx-auto w-full h-full flex flex-col md:flex-row justify-between items-center gap-24 xl:gap-32  pt-[126px] md:pt-[96px] py-[96px]">
        <div className="flex basis-2/4 flex-col flex-wrap gap-[36px] items-start">
          <div className="space-y-4">
            <h2
              className="hero-heading text-[38px] md:text-[54px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[64px] text-white"
              dangerouslySetInnerHTML={{
                __html:
                  "Secure Data Infrastructure for Enterprise AI and Analytics",
              }}
            />
            <p className="hero-copy text-sm md:text-base text-center md:text-left font-medium text-[#FFF] leading-5">
              [AI] Analytics Intelligence delivers managed APU compute
              infrastructure for enterprise analytics workloads, processing data
              up to 100× faster, alongside an analytics reasoning model built
              for AI agents and autonomous intelligence applications.
            </p>
          </div>
          <div className="hero-cta flex w-full justify-center md:justify-start items-center gap-4 md:gap-6">
            <Link to="/#products" onClick={() => {
              const el = document.getElementById("products");
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              <button className="btn-sweep btn-sweep-blue text-sm md:text-base font-semibold py-3 w-[170px] text-center text-white rounded-[100px] gap-2">
                Explore Products
              </button>
            </Link>

            <Link to="/contact">
              <button className="btn-sweep btn-sweep-white text-sm md:text-base font-semibold py-3 w-[170px] text-center text-poppingBlue rounded-[100px]">
                Talk to us
              </button>
            </Link>
          </div>
        </div>
        <div className="basis-2/4 flex justify-end">
          <img className="hero-media" src={AI_HERO_GIF} alt="illustration" />
        </div>
      </div>
    </section>
  );
};
